"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledBreadcrumbs = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tachyons = require("../../framework/tachyons");

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var _default = {};
exports["default"] = _default;

var StyledBreadcrumbs = _styledComponents["default"].ol.withConfig({
  displayName: "Breadcrumbsstyles__StyledBreadcrumbs",
  componentId: "sc-1x4ie0s-0"
})(["", " ", " & > li{", " &:not(:first-of-type):before{content:'", "';", " ", "}& > a{", " text-decoration:none;&:hover{text-decoration:underline;}}}"], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    list ma0 pa0 flex sans-serif fw4 lh-title ", "\n    ", "\n  "])), function (_ref) {
  var breadcrumbs = _ref.theme.breadcrumbs;
  return breadcrumbs.fontSize;
}, function (_ref2) {
  var mobileView = _ref2.mobileView;
  return mobileView === 'inline' && 'pb3';
}), function (_ref3) {
  var mobileView = _ref3.mobileView;
  var css;

  switch (mobileView) {
    case 'inline':
      css = "\n          ".concat(_tachyons.breakpoints.s, " {\n            overflow-x: auto;\n          }\n        ");
      break;

    case 'wrap':
      css = "\n          ".concat(_tachyons.breakpoints.s, " {\n            flex-wrap: wrap;\n          }\n        ");
      break;

    case 'hidden':
      css = "\n          ".concat(_tachyons.breakpoints.s, " {\n            display: none;\n          }\n        ");
      break;

    case 'previousLevel':
    default:
      css = "\n          ".concat(_tachyons.breakpoints.s, " {\n            & > li:not(:last-of-type) {\n              display: none;\n            }\n          }\n        ");
      break;
  }

  return css;
}, (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["pr1 pr2-ns nowrap"]))), function (_ref4) {
  var breadcrumbs = _ref4.theme.breadcrumbs;
  return breadcrumbs.delimiter;
}, function (_ref5) {
  var svgDelimiter = _ref5.theme.breadcrumbs.svgDelimiter;
  return svgDelimiter && "content: url('".concat(svgDelimiter, "');");
}, (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["pr2"]))), (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref6) {
  var breadcrumbs = _ref6.theme.breadcrumbs;
  return breadcrumbs.linkColor;
}));

exports.StyledBreadcrumbs = StyledBreadcrumbs;